import React, { useCallback, useEffect, useRef, useState } from 'react';
import './Login.css';
import { api } from '../services/api';
import { GOOGLE_CLIENT_ID } from '../constants/config';

export default function Login({ onLogin }) {
  const [error, setError] = useState('');
  const googleButtonRef = useRef(null);

  const handleGoogleSignIn = useCallback(async (response) => {
    setError('');

    try {
      const data = await api.googleLogin(response.credential);
      // Call onLogin with user data - App.js will handle setting state
      await onLogin(data.user);
    } catch (err) {
      setError(err.message || 'Failed to login with Google. Please try again.');
    }
  }, [onLogin]);

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) {
      setError('Google OAuth not configured. Please set GOOGLE_CLIENT_ID in constants/config.js');
      return;
    }

    // Initialize Google Sign-In
    if (window.google && window.google.accounts) {
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleGoogleSignIn,
      });

      // Render the button
      if (googleButtonRef.current) {
        window.google.accounts.id.renderButton(
          googleButtonRef.current,
          {
            theme: 'outline',
            size: 'large',
            width: '100%',
            text: 'signin_with',
          }
        );
      }
    } else {
      // Wait for Google script to load
      const checkGoogle = setInterval(() => {
        if (window.google && window.google.accounts) {
          clearInterval(checkGoogle);
          window.google.accounts.id.initialize({
            client_id: GOOGLE_CLIENT_ID,
            callback: handleGoogleSignIn,
          });

          if (googleButtonRef.current) {
            window.google.accounts.id.renderButton(
              googleButtonRef.current,
              {
                theme: 'outline',
                size: 'large',
                width: '100%',
                text: 'signin_with',
              }
            );
          }
        }
      }, 100);

      return () => clearInterval(checkGoogle);
    }
  }, [handleGoogleSignIn]);

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/logo_big.png" alt="Windmill" className="login-logo" />
          <h1 className="login-title">Welcome to Windmill</h1>
          <p className="login-subtitle">Sign in with your Google account</p>
        </div>

        <div className="login-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div 
            ref={googleButtonRef} 
            className="google-signin-button"
            style={{ 
              display: 'flex', 
              justifyContent: 'center',
              marginTop: '1rem'
            }}
          />

          <p className="login-footer">
            New users will be automatically created
          </p>
        </div>
      </div>
    </div>
  );
}

